module.exports = " <div class=\"color-palette clearfix\" _v-3488a6e8=\"\"> <div class=\"palette-button color-palette-item\" data-cmd=setColor data-arg=\"{{ color }}\" v-for=\"(idx, color) in state.AVAILABLE_COLORS\" _v-3488a6e8=\"\"> <div class=color-fill v-bind:style=\"{ 'background-color': color }\" _v-3488a6e8=\"\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3488a6e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/palettes/Colors.vue
// module id = 182
// module chunks = 2